import moment from "moment";
import ParticipantsTooltip from "./ParticipantsTooltip";
import { useTranslation } from "react-i18next";

const LastServiceCard = ({ service }) => {
  const { t } = useTranslation();
  return (
    <div className="card-last-service">
      <div className="header">
        <div className="status">{service.status.name}</div>
        <div>{service.index}</div>
        <div>
          {moment(service.plannedServiceDateTime).isValid() && (
            <>
              <span className="dot yellow"></span>
              {moment(service.plannedServiceDateTime).format(
                "DD/MM/YYYY HH:mm",
              )}
            </>
          )}
        </div>

        <div>
          {moment(service.startDateTime).isValid() && (
            <>
              <span className="dot green"></span>
              {moment(service.startDateTime).format("DD/MM/YYYY HH:mm")}
            </>
          )}
        </div>

        <div>
          {moment(service.endDateTime).isValid() && (
            <>
              <span className="dot red"></span>
              {moment(service.endDateTime).format("DD/MM/YYYY HH:mm")}
            </>
          )}
        </div>

        <div>
          <ParticipantsTooltip
            leader={service.technicianOrTeamLeader}
            others={service.techniciansInTheGroup}
          />
        </div>
      </div>

      <div className="section">
        <div className="label">
          {t("global:service.problemDescriptionsDictionary")}
        </div>
        <div className="text">
          {service?.problemDescriptionsDictionary
            ?.map((p) => p.entryName)
            .filter(Boolean)
            .join(" • ")}
        </div>
      </div>

      <div className="section">
        <div className="label">{t("global:service.tasksDictionary")}</div>
        <div className="text">
          {service?.tasksDictionary
            ?.map((p) => p.entryName)
            .filter(Boolean)
            .join(" • ")}
        </div>
      </div>

      <div className="section">
        <div className="label">
          {t("global:service.additionalLogisticsDescription")}
        </div>
        <div className="text">{service?.additionalLogisticsDescription}</div>
      </div>

      <div className="section">
        <div className="label">{t("global:service.interventionScope")}</div>
        <div className="text">{service?.interventionScope}</div>
      </div>

      <div className="section">
        <div className="label">
          {t("global:service.technicianNotesNextIntervention")}
        </div>
        <div className="text">{service?.technicianNotesNextIntervention}</div>
      </div>
    </div>
  );
};

export default LastServiceCard;
